import { beam } from '@styles/colors/themes';
import { zIndexes } from '@styles/zindex/zindex';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  padding: 12px 16px 24px 16px;
  z-index: ${zIndexes.indexOf('overlay-menu')};
`;

export const Label = styled.h2`
  color: ${beam.font.label};
  margin-bottom: 8px;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
`;

export const Content = styled.h2`
  color: #474d66;
  font-size: 14px;
  font-weight: 500;

  &.email {
    color: #696f8c;
    font-size: 12px;
    font-weight: 400;
  }
`;

export const Tag = styled.h2`
  color: ${beam.font.primary};
  font-size: 14px;
  font-weight: 400;
  border-radius: 12px;
  background: ${beam.background.tag};
  color: ${beam.color.pureWhite};
  padding: 2px 10px 1px;
`;

export const Header = styled.h1`
  color: #1b203a;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 24px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-weight: 500;
  align-items: center;
`;

export const Line = styled.div`
  height: 0;
  width: 100%;
  margin-bottom: 16px;

  /* borders/default-border */
  border-top: 1px solid ${beam.border.back};
`;

export const Input = styled.input`
  border-radius: 8px;
  border: 1px solid #e9edf1;
  background: #fff;
  color: #838a91;
  font-size: 16px;
  padding: 5px 12px;
  width: 100%;
`;

export const Block = styled.div`
  background: #fff;
  padding: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.161);
  border-radius: 8px;
  position: absolute;
  top: 0;
  left: 100%;
  min-width: 200px;
  min-height: 200px;
  z-index: 11;
`;

interface IItem {
  active: boolean;
}

export const Item = styled.div<IItem>`
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  background: ${({ active }) => (active ? '#F6F8FF' : '#fff')};
  cursor: pointer;
`;

interface IItemListText {
  active: boolean;
}

export const ItemListText = styled.div<IItemListText>`
  font-size: 14px;
  flex: 1;
  color: ${({ active }) => (active ? '#1371FE' : '#1a1b1c')};
`;

export const WindowButton = styled.div`
  display: flex;
  cursor: pointer;
  border: 0;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 8px;
  width: 32px;
  height: 32px;
  padding: 0;

  transition: 0.2s;

  :hover {
    background-color: #e6edff;
  }
`;

export const WindowButtonImage = styled.img``;

export const Buttons = styled.button`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  padding: 8px;
  border: 0;
  background-color: transparent;
  height: 38px;
  color: #474d66;
  font-size: 14px;
  font-weight: 400;

  transition: 0.2s;

  :hover {
    background-color: #f5f7fb;
    border-radius: 4px;
  }
`;

export const DateDiv = styled.div`
  /* Layout Properties */
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 16px;
  & .react-date-picker {
    & .react-date-picker__wrapper {
      border: none;
      height: 100%;
      display: flex;
      justify-content: center;
    }
    & .react-calendar {
      width: 400px !important;
      display: table-caption;
    }
  }
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const ProfileImg = styled.img`
  width: 44px;
  height: 44px;
  border-radius: 22px;
  object-fit: cover;
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 8px 0 0 8px;
  border-bottom: 1px solid #e6e8f0;
  margin-bottom: 4px;
`;

export const Column = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: -12px;
`;

export const Hf = styled.div`
  width: 100%;
  border-bottom: 1px solid #e6e8f0;
  margin: 4px 0;
`;
